import React from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { isRouteAllowedForRole } from '../config/routePermissions';

/**
 * Route-level access guard. Runs inside the authenticated /app layout tree.
 * If the current user's role is not permitted for the requested pathname
 * (per src/config/routePermissions.js), redirect to /app/403 and preserve
 * the attempted path in location state for user feedback.
 *
 * Layout stays mounted (sidebar/topbar still visible) — only the outlet
 * content is swapped for the 403 page.
 */
export default function RoleGuardOutlet() {
  const { user, loading } = useAuth();
  const location = useLocation();

  // ProtectedRoute already handles unauth. While auth is loading, let it render.
  if (loading || !user) {
    return <Outlet />;
  }

  const allowed = isRouteAllowedForRole(user.role, location.pathname);

  if (!allowed) {
    // Don't loop: never redirect from /app/403 back to /app/403
    if (location.pathname.replace(/\/+$/, '') === '/app/403') {
      return <Outlet />;
    }
    return (
      <Navigate
        to="/app/403"
        replace
        state={{ from: location.pathname + (location.search || '') }}
      />
    );
  }

  return <Outlet />;
}
